import { render, staticRenderFns } from "./MenuMovimenti.vue?vue&type=template&id=6e38e4b0&scoped=true&"
import script from "./MenuMovimenti.vue?vue&type=script&lang=js&"
export * from "./MenuMovimenti.vue?vue&type=script&lang=js&"
import style0 from "./MenuMovimenti.vue?vue&type=style&index=0&id=6e38e4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38e4b0",
  null
  
)

export default component.exports